import React, { useRef, useState, useEffect } from 'react';
import { TurningIconState, height } from '@components/operatorLobby/telemetry/IconStates';
import iconActiveLeft from "@public/img/signal/Signal_left.png"
import iconActiveFadedLeft from "@public/img/signal/Signal_left_faded.png"
import iconActiveRight from "@public/img/signal/Signal_right.png"
import iconActiveFadedRight from "@public/img/signal/Signal_right_faded.png"
import iconInactive from "@public/img/signal/Signal_transparent.png"
import clignotant1 from "@public/sound/clignotant1.mp3"
import clignotant2 from "@public/sound/clignotant2.mp3"

let isActive = false
let audio_clignotant1 = new Audio(clignotant1);
let audio_clignotant2 = new Audio(clignotant2);

export default function TurningIcon({ state=TurningIconState.INACTIVE }) {
  const iconLeft = useRef(null);
  const iconRight= useRef(null);
  const [srcLeft, setSrcLeft] = useState("");
  const [srcRight, setSrcRight] = useState("");
  const frequency = 2

  useEffect(() => {
    let isFaded = true
    const interval = setInterval(() => {
      if (isActive){
        if (isFaded){
          audio_clignotant1.play()
          isFaded = false
          if(state === TurningIconState.BOTH){
            setSrcRight(iconActiveFadedRight);
            setSrcLeft(iconActiveFadedLeft);
          } else if (state === TurningIconState.RIGHT){
            setSrcRight(iconActiveFadedRight);
            setSrcLeft(iconInactive);
          } else if (state === TurningIconState.LEFT){
            setSrcRight(iconInactive);
            setSrcLeft(iconActiveFadedLeft);
          } 
    
        } else {
          audio_clignotant2.play()
          isFaded = true
          if(state === TurningIconState.BOTH){
            setSrcRight(iconActiveRight);
            setSrcLeft(iconActiveLeft);
          } else if (state === TurningIconState.RIGHT){
            setSrcRight(iconActiveRight);
            setSrcLeft(iconInactive);
          } else if (state === TurningIconState.LEFT){
            setSrcRight(iconInactive);
            setSrcLeft(iconActiveLeft);
          } 
        }
      }
    }, 1000/frequency);
    return () => clearInterval(interval);
  }, [ state ]);

  useEffect(() => {
    var currentIconRight,currentIconLeft;
    switch (state) {
      case TurningIconState.BOTH:
        currentIconRight = iconActiveRight;
        currentIconLeft = iconActiveLeft;
        isActive = true
        break;
      case TurningIconState.RIGHT:
        currentIconRight = iconActiveRight;
        currentIconLeft = iconInactive;
        isActive = true
        break;
      case TurningIconState.LEFT:
        currentIconRight = iconInactive;
        currentIconLeft = iconActiveLeft;
        isActive = true
        break;
      case TurningIconState.INACTIVE:
        isActive = false
        currentIconRight = iconInactive;
        currentIconLeft = iconInactive;
        break;
      default:
        isActive = false
        currentIconRight = iconInactive;
        currentIconLeft = iconInactive;
    }
    setSrcRight(currentIconRight);
    setSrcLeft(currentIconLeft);

  },[ state ]);
 
  return <div className='turnSignal'>
            <img ref={iconLeft} src={srcLeft} alt="TurningLeftIcon" height={height} />
            <img ref={iconRight} src={srcRight} alt="TurningRightIcon" height={height} /> 
         </div>

  
}
